import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-code-enforcement',
  templateUrl: './code-enforcement.component.html',
  styleUrls: ['./code-enforcement.component.scss']
})
export class CodeEnforcementComponent implements OnInit {

  constructor(private activeRouter: ActivatedRoute,
    private router: Router) { }

  ngOnInit(): void {
  }

  gotoAddress() {
    this.router.navigate(['/search-address', { isAddress: true }])
  }

  gotoCreateCase() {
    this.router.navigate(['/create-case'])
  }

  gotoExpiredCase() {
    this.router.navigate(['/expired-case'])
  }

  gotoCaseList() {
    this.router.navigate(['/case-listing'])

  }

}
